import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const TextBoxComponent = forwardRef(
  (
    {
      name,
      value,
      onChange,
      handleInput,
      placeholder = "",
      className = "",
      disabled = false,
      type = "text",
      style = {},
      errors,
      autoFocus = false,
      ...rest
    },
    ref
  ) => {
    return (
      <div className="d-flex flex-column w-100">
        <input
          ref={ref}
          type={type}
          name={name}
          value={value}
          onChange={onChange || handleInput}
          className={`form-control ${className}`}
          placeholder={placeholder}
          disabled={disabled}
          style={style}
          autoFocus={autoFocus}
          {...rest}
        />
        {errors && <span className="text-danger fs-14">{errors}</span>}
      </div>
    );
  }
);

TextBoxComponent.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  style: PropTypes.object,
  autoFocus: PropTypes.bool,
};

export default TextBoxComponent;
